<div *ngIf="field" class="field-label">{{field.label | translate }} <i *ngIf="field.info" class="pi pi-info-circle" style="vertical-align: middle;" [pTooltip]="field.info"></i></div>
